export const PLAN_LIMITS = {
  free: {
    id: "free",
    label: "Free",
    invoiceLimit: 10,
    maxQuickSelectCustomers: 3,
    maxQuickSelectJobs: 3,
    editableFieldsBeforeNewInvoice: 5,
    canAccessMetrics: false,
  },
  pro: {
    id: "pro",
    label: "Pro",
    invoiceLimit: Infinity,
    maxQuickSelectCustomers: Infinity,
    maxQuickSelectJobs: Infinity,
    editableFieldsBeforeNewInvoice: Infinity,
    canAccessMetrics: true,
  },
};
